import { Box, IconButton, SvgIcon, Typography } from "@mui/material";
import React, { useState } from "react";
import VerifiedBadgeInfoDialog from "./VerifiedBadgeInfoDialog";

const VerifiedBadge = ({
  isVerified = true,
  variant,
}: {
  isVerified: boolean;
  variant?: string;
}) => {
  const [isInfoDialogVisible, setIsInfoDialogVisible] =
    useState<boolean>(false);

  if (!isVerified) {
    return null;
  }

  return (
    <>
      <Box sx={{ ml: 1 }}>
        <Typography
          color="white"
          variant="caption"
          sx={{
            backgroundColor: "#4267B2",
            px: variant === "small" ? 0.5 : 0.8,
            py: variant === "small" ? 0.1 : 0.2,
            borderRadius: 1.5,
            cursor: "pointer",
            fontWeight: 600,
          }}
          onMouseDown={(e) => e.stopPropagation()}
          onClick={(e) => {
            e.stopPropagation();
            e.preventDefault();
            setIsInfoDialogVisible(true);
          }}
        >
          cxo
        </Typography>
      </Box>
      <VerifiedBadgeInfoDialog
        open={isInfoDialogVisible}
        onClose={() => {
          setIsInfoDialogVisible(false);
        }}
      />
    </>
  );
};

export default VerifiedBadge;
